/** General purpose text utilities */
import linkifyStr from 'linkifyjs/string';
import linkifyHtml from 'linkifyjs/html';

/* Hacky function to convert html to vaguely presentable text.
 * - Inject spaces so that text inside tightly-formatted html isn't glommed together.
 * - Pass through a temporary elemnt to extra the innerText
 * - Finally trim start/end spaces.
 */
export function htmlToText(html) {

    if (!html) { return ''; }
    let temp = document.createElement("div");

    html = html.replace("</p>", "</p>\n");
    temp.innerHTML = html.replaceAll("><", "> <");

    // temp isn't RENDERED, so innerText is equivalent to textContent :-(
    let out = nl2br((temp.innerText || "").trim(), false);
    // console.log("htmlToText", out);
    return out;
    // return temp.textContent || temp.innerText || "";
}


export function nl2br(str, is_xhtml) {
    if (typeof str === 'undefined' || str === null) {
        return '';
    }
    var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
}


export function formatRawText(raw) {
    if (!raw) { return ''; }
    if (raw.indexOf('<') !== -1) {
        // Assume this is html
        return linkifyHtml(raw, {defaultProtocol: 'https'});
    } else {
        return linkifyStr(raw, {nl2br: true, defaultProtocol: 'https'});
    }
}


export function formatBytes(bytes, decimals = 2) {
    if (!+bytes) return '0 Bytes'

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}
